module.exports = __webpack_public_path__ + "static/img/login2.c3cdee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login2.png
// module id = uEwH
// module chunks = 1